<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: "LayoutTemplate"
};
</script>



// WEBPACK FOOTER //
// src/views/Layout/template.vue